import DeleteButton from 'CMFW/button/DeleteButton';
import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import { ContainerLeft, EditorGapGreedyH, EditorRow } from 'components/common/styles';
import React, { useContext } from 'react';
import styled from 'styled-components';
import Translations from '../../../components/translation/Translations';
import TextInput from 'CMFW/input/TextInput';
import Checkbox from 'CMFW/input/Checkbox';

const MemoryPhrasebookEdit: React.FC = () => {
  const module = useContext(ModuleContext);

  return (
    <ContainerLeft>
      <EditorRow>
        <EditorGapGreedyH />
        <SaveButton />
      </EditorRow>
      <NotesInput keyName={'example'} label={'Example/Definition'} multiline />
      <InvariableCheckbox keyName={'isInvariable'} label={'Invariable (same in all dialects)'} />
      <Scroll>
        <Translations keyName={'dialects'} refId={module.ref} memory={false} search={false} />
      </Scroll>
      <DeleteButton />
    </ContainerLeft>
  );
};

export default MemoryPhrasebookEdit;

const Scroll = styled.div`
  height: 100%;
  overflow: auto;
`;

const NotesInput = styled(TextInput)`
  margin-top: 10px;
`;

const InvariableCheckbox = styled(Checkbox)`
  margin-top: 10px;
`;
